import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function CancellationPolicyPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Header */}
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft size={20} />
            <span>Go Back</span>
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-serif text-white mb-4">Cancellation Policy</h1>
          <p className="text-zinc-400">Last Updated: April 2026</p>
        </div>

        <div className="space-y-10 text-zinc-300">
          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Host-Defined Policies</h2>
            <p className="mb-4">Hosts may define:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400 mb-4">
              <li>Flexible cancellation</li>
              <li>Moderate cancellation</li>
              <li>Strict cancellation</li>
            </ul>
            <p className="text-zinc-500">100Nook may provide recommended templates.</p>
          </section>

          <hr className="border-white/10" />

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Platform Cancellations</h2>
            <p className="mb-4">100Nook may cancel bookings if:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Safety concerns</li>
              <li>Fraud detection</li>
              <li>Policy violations</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Refund Conditions</h2>
            <p className="mb-4 font-semibold text-white">Refunds may be issued for:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400 mb-6">
              <li>Host cancellation</li>
              <li>Property unavailable</li>
              <li>Safety concerns</li>
            </ul>
            <p className="mb-4 font-semibold text-white">Refunds may not be issued for:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>No-shows</li>
              <li>Late cancellations</li>
            </ul>
          </section>
        </div>

        {/* Footer CTA */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-zinc-500 text-sm">
            Questions about cancellations? Contact us at{' '}
            <a href="mailto:admin@100nook.com" className="text-[#D4AF37] hover:underline">
              admin@100nook.com
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
